// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { apiOrchestratorPricingCommittee } from '@store/apiSlices/apiSlices';
import { ModelError } from '@store/apiSlices/interfaces/interfaces';

import {
  EventReceptionRequest,
  EventReceptionResponse,
} from '../../interfaces/interfaces';

export const eventReceptionApi =
  apiOrchestratorPricingCommittee.injectEndpoints({
    endpoints: builder => ({
      createEventReception: builder.mutation<
        EventReceptionResponse,
        EventReceptionRequest
      >({
        query: body => ({
          url: '/event-reception',
          method: 'POST',
          body,
        }),
        transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
          const modelError: ModelError = {
            errorStatus: error.status,
            messageFromServer: (error.data as any)?.message,
            serviceErrorName: 'createEventReception',
          };
          return modelError;
        },

        transformResponse: (
          response: EventReceptionResponse
        ): EventReceptionResponse => {
          return response;
        },
        async onQueryStarted(arg, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled;

            setTimeout(() => {
              dispatch(
                eventReceptionApi.util.invalidateTags([
                  {
                    type: 'CurrentOrchestrator' as const,
                    id: `${arg.country ?? 'all'}:${arg.nid ?? 'current'}`,
                  },
                ])
              );
            }, 2000);
          } catch {
            // mutation failed — nothing to invalidate
          }
        },
      }),
    }),
  });

export const { useCreateEventReceptionMutation } = eventReceptionApi;
